import { render, staticRenderFns } from "./ExportacaoAFD.vue?vue&type=template&id=c4891718"
import script from "./ExportacaoAFD.vue?vue&type=script&lang=js"
export * from "./ExportacaoAFD.vue?vue&type=script&lang=js"
import style0 from "./ExportacaoAFD.vue?vue&type=style&index=0&id=c4891718&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports